import { Floor } from '@/entities/map'
import { useMultiScrollState } from '@/shared/lib'

import { Filter, useFilter } from '../../model/filter'
import { Title, List, Item } from '../common/layout'

const FLOORS = [
  {
    title: '반지하',
    value: Floor.SEMI_BASEMENT,
  },

  {
    title: '1층',
    value: Floor.FIRST_FLOOR,
  },
  {
    title: '2층 ~ 9층',
    value: Floor.FROM_SECOND_TO_NINE,
  },
  {
    title: '10층 이상',
    value: Floor.OVER_TEN,
  },
]

type Props = {
  className?: string
}

export const Floors = ({ className }: Props) => {
  const { registerScrollElement } = useMultiScrollState<HTMLDivElement>()

  const {
    type,
    filter: { floors },
    updateFilter,
  } = useFilter()

  const handleFloorChange = (value: Floor) => () => {
    updateFilter({ floors: value })
  }

  return (
    <div
      className={className}
      ref={element => {
        if (element) {
          registerScrollElement(Filter.Floors, element)
        }
      }}
    >
      <Title>층수</Title>
      <List>
        {FLOORS.map(({ title, value }) => (
          <Item
            key={value}
            type={type}
            selected={floors.includes(value)}
            onClick={handleFloorChange(value)}
          >
            {title}
          </Item>
        ))}
      </List>
    </div>
  )
}
